import { createAction } from 'Lib/reduxUtils';

import {
  API_HELPER_INITIATED,
  APP_OFFLINE,
  APP_ONLINE,
  DEACTIVATE_TAB,
  DEVICE_FLAGGED_FOR_DOB_VIOLATION,
  DEVICE_UNFLAGGED_FOR_DOB_VIOLATION,
  GET_EXPERIMENTS,
  GET_EXPERIMENTS_ERROR,
  GET_EXPERIMENTS_SUCCESS,
  LEVERS_PARSED,
  SET_APP_SOURCE,
  SET_AUTH_ATTRIBUTION_DATA,
  SET_AV_PERMISSION_STATUS,
  SET_BRANDING,
  SET_DOB_VIOLATION_TIMEOUT,
} from './constants';
import type { AuthAttributionData, AVPermissionStatuses, Brandings } from './types';

export const apiHelperInitiated = createAction(API_HELPER_INITIATED);
export const appOffline = createAction(APP_OFFLINE);
export const appOnline = createAction(APP_ONLINE);
export const deactivateTab = createAction(DEACTIVATE_TAB);

export const deviceUnflaggedForDobViolation = createAction(DEVICE_UNFLAGGED_FOR_DOB_VIOLATION);
export const deviceFlaggedForDobViolation = createAction(
  DEVICE_FLAGGED_FOR_DOB_VIOLATION,
  (birthdate?: string | null, ttl?: string | null, isAppealable?: boolean) => ({
    birthdate,
    ttl,
    isAppealable,
  })
);
export const setDobViolationDaysLeft = createAction(
  SET_DOB_VIOLATION_TIMEOUT,
  (timeout: number | null) => timeout
);

export const getExperiments = createAction(GET_EXPERIMENTS);
export const getExperimentsSuccess = createAction(
  GET_EXPERIMENTS_SUCCESS,
  ({ result }: { result: any }) => ({
    result,
  })
);
export const getExperimentsError = createAction(GET_EXPERIMENTS_ERROR, (error: any) => ({
  error,
}));
export const setAvPermissionStatus = createAction(
  SET_AV_PERMISSION_STATUS,
  (status: AVPermissionStatuses) => status
);
export const leversParsed = createAction(LEVERS_PARSED, (levers: any) => ({ levers }));
export const setBranding = createAction(SET_BRANDING, (branding: Brandings) => branding);
export const setAuthAttributionData = createAction(
  SET_AUTH_ATTRIBUTION_DATA,
  (authAttributionData: AuthAttributionData) => authAttributionData
);
export const setAppSource = createAction(SET_APP_SOURCE, (source: string) => source);
